<template>
  <Modal
    :show="show"
    hide-default-actions
    width="376px"
    @close="handleClose"
  >
    <template #title>
      <h5>Create Employee Acknowledgement</h5>
    </template>
    <template #content>
      <p class="text-textLight text-body-3 mb-4">
        Click "Create Acknowledgement" to send the below employee a link via e-mail to acknowledge
        the job profile below.
      </p>
      <div class="info-section">
        <div class="info-header">
          <span class="info-label text-body-2">Employee</span>
        </div>
        <div class="info-value">
          <p class="text-body-3">
            {{ employeeName }}
          </p>
        </div>
      </div>
      <div class="info-section">
        <div class="info-header">
          <span class="info-label text-body-2">Job Profile</span>
        </div>
        <div class="info-value">
          <p class="text-body-3">
            {{ jobProfile }}
          </p>
        </div>
      </div>
      <div class="action-section">
        <DpplNewButton
          class="w-100"
          color="primary"
          size="small"
          :disabled="loading"
          @click="handleCreateAcknowledgement"
        >
          {{ buttonText }}
        </DpplNewButton>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import Modal from '@/components/shared/Modal.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  employeeName: { type: String, default: '' },
  employeeEmail: { type: String, default: '' },
  jobProfile: { type: String, default: '' },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'create']);

const buttonText = computed(() => {
  if (props.loading) {
    return 'Sending Acknowledgement E-mail...';
  }
  return 'Create Acknowledgement';
});

const handleClose = () => {
  emit('close');
};

const handleCreateAcknowledgement = () => {
  emit('create');
};
</script>

<style scoped lang="less">
:deep(.content) {
  margin-top: 0 !important;
}

.info-section {
  display: flex;
  flex-direction: column;
  width: 325px;
  margin-bottom: 16px;
}

.info-section:last-of-type {
  margin-bottom: 0;
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.info-label {
  color: @text-darkest;
}

.info-value {
  color: @text-light;
}

.action-section {
  border-top: 1px solid @stroke-default;
  padding-top: 16px;
  margin-top: 16px;
}

:deep(.modal-content-wrapper.pr-6.pl-6) {
  padding: 0 !important;
}
</style>
